import {
  action,
  computed,
  makeObservable,
  observable,
  reaction,
  toJS
} from "./chunk--chunk-SSDFD27P.vbt.js";
import {
  __commonJS,
  __export,
  __toESM
} from "./chunk--chunk-Z7A6LSGX.vbt.js";

// node_modules/deepmerge/dist/cjs.js
var require_cjs = __commonJS({
  "node_modules/deepmerge/dist/cjs.js"(exports, module) {
    "use strict";
    var isMergeableObject = function isMergeableObject2(value) {
      return isNonNullObject(value) && !isSpecial(value);
    };
    function isNonNullObject(value) {
      return !!value && typeof value === "object";
    }
    function isSpecial(value) {
      var stringValue = Object.prototype.toString.call(value);
      return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
    }
    var canUseSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
    function isReactElement(value) {
      return value.$$typeof === REACT_ELEMENT_TYPE;
    }
    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }
    function cloneUnlessOtherwiseSpecified(value, options) {
      return options.clone !== false && options.isMergeableObject(value) ? deepmerge2(emptyTarget(value), value, options) : value;
    }
    function defaultArrayMerge(target, source, options) {
      return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
      });
    }
    function getMergeFunction(key, options) {
      if (!options.customMerge) {
        return deepmerge2;
      }
      var customMerge = options.customMerge(key);
      return typeof customMerge === "function" ? customMerge : deepmerge2;
    }
    function getEnumerableOwnPropertySymbols(target) {
      return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
      }) : [];
    }
    function getKeys(target) {
      return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
    }
    function propertyIsOnObject(object, property) {
      try {
        return property in object;
      } catch (_) {
        return false;
      }
    }
    function propertyIsUnsafe(target, key) {
      return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
    }
    function mergeObject(target, source, options) {
      var destination = {};
      if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
          destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
      }
      getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
          return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
          destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
          destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
      });
      return destination;
    }
    function deepmerge2(target, source, options) {
      options = options || {};
      options.arrayMerge = options.arrayMerge || defaultArrayMerge;
      options.isMergeableObject = options.isMergeableObject || isMergeableObject;
      options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
      var sourceIsArray = Array.isArray(source);
      var targetIsArray = Array.isArray(target);
      var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
      if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
      } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
      } else {
        return mergeObject(target, source, options);
      }
    }
    deepmerge2.all = function deepmergeAll(array, options) {
      if (!Array.isArray(array)) {
        throw new Error("first argument should be an array");
      }
      return array.reduce(function(prev, next) {
        return deepmerge2(prev, next, options);
      }, {});
    };
    var deepmerge_1 = deepmerge2;
    module.exports = deepmerge_1;
  }
});

// node_modules/@searchspring/snap-toolbox/dist/esm/DomTargeter/DomTargeter.js
var globallyTargetedElems = [];
var DomTargeter = class {
  constructor(targets, onTarget, document2) {
    this.targets = [];
    this.styleBlockRefs = {};
    this.targetedElems = [];
    this.unhideTarget = (selector) => {
      if (this.styleBlockRefs[selector]) {
        try {
          this.document.head.removeChild(this.styleBlockRefs[selector]);
          delete this.styleBlockRefs[selector];
        } catch (err) {
        }
      }
    };
    this.hideTarget = (selector) => {
      if (this.styleBlockRefs[selector])
        return;
      const styles = `${selector} { visibility: hidden !important }`;
      const styleBlock = this.document.createElement("style");
      styleBlock.setAttribute("type", "text/css");
      styleBlock.appendChild(this.document.createTextNode(styles));
      this.document.head.appendChild(styleBlock);
      this.styleBlockRefs[selector] = styleBlock;
    };
    this.document = document2 || window.document;
    this.targets = targets;
    this.onTarget = onTarget;
    this.retarget();
    this.targets.forEach((target) => {
      let timeoutTime = 100;
      const checker = () => {
        if (timeoutTime < 2e3) {
          timeoutTime = timeoutTime + 200;
          this.retarget();
          setTimeout(checker, timeoutTime);
        } else {
          target.hideTarget && this.unhideTarget(target.selector);
        }
      };
      if (target.clickRetarget) {
        let clickElems = [];
        if (typeof target.clickRetarget == "boolean") {
          clickElems.push(this.document);
        } else {
          clickElems = Array.from(this.document.querySelectorAll(target.clickRetarget));
        }
        clickElems.map((elem) => {
          elem.addEventListener("click", () => {
            timeoutTime = 100;
            checker();
          });
        });
      }
      if (target.autoRetarget) {
        checker();
      } else if (/complete|interactive|loaded/.test(this.document.readyState)) {
        target.hideTarget && this.unhideTarget(target.selector);
      } else {
        this.document.addEventListener("DOMContentLoaded", () => {
          this.retarget();
          target.hideTarget && this.unhideTarget(target.selector);
        });
      }
    });
  }
  getTargets() {
    return this.targets;
  }
  retarget() {
    const targetElemPairs = this.targets.flatMap((target) => {
      target.hideTarget && this.hideTarget(target.selector);
      const elems = this.domQuery(target.selector).filter((elem) => {
        if (!globallyTargetedElems.find((e) => e == elem) && !this.targetedElems.find((e) => e == elem)) {
          return true;
        } else {
          target.hideTarget && this.unhideTarget(target.selector);
        }
      });
      if (!target.inject?.element) {
        globallyTargetedElems = globallyTargetedElems.concat(elems);
      }
      return elems.map((elem) => ({ target, elem }));
    });
    const errors = [];
    targetElemPairs.forEach(({ target, elem }) => {
      if (target.inject) {
        try {
          const injectedElem = this.inject(elem, target);
          this.targetedElems = this.targetedElems.concat(elem);
          this.onTarget(target, injectedElem, elem);
        } catch (e) {
          errors.push(String(e));
        }
      } else {
        target.emptyTarget = target.emptyTarget ?? true;
        if (target.emptyTarget)
          while (elem.firstChild && elem.removeChild(elem.firstChild))
            ;
        this.onTarget(target, elem);
      }
      target.hideTarget && this.unhideTarget(target.selector);
    });
    if (errors.length) {
      throw new Error(errors.reduce((acc, err) => acc += err + "\n", "\n"));
    }
  }
  domQuery(selector) {
    return Array.from(this.document.querySelectorAll(selector));
  }
  inject(elem, target) {
    if (!target || !target.inject) {
      throw new Error("DomTargeter::inject: Injected element unspecified");
    }
    const injectedElem = target.inject.element instanceof Function ? target.inject.element(target, elem) : target.inject.element;
    if (!injectedElem) {
      throw new Error("DomTargeter::inject: Injected element unspecified");
    }
    if (!elem.parentNode) {
      throw new Error("DomTargeter::inject: Provided element has no parent element");
    }
    switch (target?.inject?.action) {
      case "before":
        elem.parentNode.insertBefore(injectedElem, elem);
        break;
      case "after":
        if (elem.nextSibling) {
          elem.parentNode.insertBefore(injectedElem, elem.nextSibling);
        } else {
          elem.parentNode.appendChild(injectedElem);
        }
        break;
      case "append":
        elem.appendChild(injectedElem);
        break;
      case "prepend":
        if (elem.firstChild) {
          elem.insertBefore(injectedElem, elem.firstChild);
        } else {
          elem.appendChild(injectedElem);
        }
        break;
      case "replace":
        elem.parentNode.replaceChild(injectedElem, elem);
        break;
    }
    return injectedElem;
  }
};

// node_modules/@searchspring/snap-toolbox/dist/esm/getContext/getContext.js
function getContext(evaluate = [], script) {
  if (!script || typeof script === "string") {
    const scripts = Array.from(document.querySelectorAll(script || 'script[id^=searchspring], script[src*="snapui.searchspring.io"]'));
    script = scripts.sort((a, b) => {
      return a.innerHTML.length - b.innerHTML.length;
    }).pop();
  }
  if (!script || typeof script !== "object" || script.tagName !== "SCRIPT") {
    throw new Error("getContext: did not find a script tag");
  }
  const scriptElem = script;
  if (!scriptElem.getAttribute("type")?.match(/^searchspring/i) && !scriptElem.id?.match(/^searchspring/i) && !scriptElem.src?.match(/\/\/snapui.searchspring.io/i)) {
    throw new Error('getContext: did not find a script from Snap CDN or with attribute (type, id) starting with "searchspring"');
  }
  if (evaluate && !Array.isArray(evaluate) || evaluate && !evaluate.reduce((accu, name) => accu && typeof name === "string", true)) {
    throw new Error("getContext: first parameter must be an array of strings");
  }
  const siteIdString = "siteId";
  const variables = {};
  evaluate?.forEach((name) => {
    const fn = new Function(`
			var ${evaluate.join(", ")};
			${scriptElem.innerHTML}
			return ${name};
		`);
    variables[name] = fn();
  });
  Object.values(scriptElem.attributes).map((attr) => {
    const name = attr.nodeName;
    if (evaluate.includes(name)) {
      variables[name] = scriptElem.getAttribute(name);
    }
  });
  Object.keys(variables).forEach((key) => {
    if (typeof variables[key] === "undefined")
      delete variables[key];
  });
  if (evaluate.includes(siteIdString)) {
    if (!variables[siteIdString]) {
      const siteId = script.getAttribute("src")?.match(/.*snapui.searchspring.io\/([a-zA-Z0-9]{6})\//);
      if (siteId && siteId.length > 1) {
        variables.siteId = siteId[1];
      }
    }
  }
  return variables;
}

// node_modules/@searchspring/snap-toolbox/dist/esm/types.js
var AppMode;
(function(AppMode2) {
  AppMode2["production"] = "production";
  AppMode2["development"] = "development";
})(AppMode || (AppMode = {}));

// node_modules/@searchspring/snap-toolbox/dist/esm/filters/filters.js
var filters_exports = {};
__export(filters_exports, {
  currency: () => currency,
  formatNumber: () => formatNumber,
  handleize: () => handleize,
  stripHTML: () => stripHTML,
  truncate: () => truncate
});

// node_modules/@searchspring/snap-toolbox/dist/esm/filters/formatNumber.js
function formatNumber(input, opts) {
  const options = {
    symbol: "",
    decimalPlaces: 3,
    padDecimalPlaces: true,
    thousandsSeparator: "",
    decimalSeparator: ".",
    symbolAfter: false,
    ...opts
  };
  if (typeof input != "number" || Number.isNaN(input)) {
    return;
  }
  const split = truncateDecimals(input, options.decimalPlaces).split(".");
  split[0] = split[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + options.thousandsSeparator);
  if (options.decimalPlaces > 0 && options.padDecimalPlaces) {
    split[1] = (split[1] || "").padEnd(options.decimalPlaces, "0");
  }
  let output = split.join(options.decimalSeparator);
  if (options.symbolAfter) {
    output = output + options.symbol;
  } else {
    output = options.symbol + output;
  }
  return output;
}
function truncateDecimals(input, digits) {
  const numString = input.toString();
  const decimalPosition = numString.indexOf(".");
  const substrLength = decimalPosition == -1 ? numString.length : 1 + decimalPosition + (digits || -1);
  return numString.substr(0, substrLength);
}

// node_modules/@searchspring/snap-toolbox/dist/esm/filters/currency.js
function currency(input, opts) {
  const defaultOptions = {
    symbol: "$",
    thousandsSeparator: ",",
    decimalPlaces: 2,
    ...opts
  };
  return formatNumber(input, defaultOptions);
}

// node_modules/@searchspring/snap-toolbox/dist/esm/filters/handleize.js
function handleize(input) {
  if (typeof input != "string") {
    return input;
  }
  let handleized = input.toLowerCase();
  handleized = handleized.replace(/[^\w\s]/g, "").trim();
  handleized = handleized.replace(/\s/g, "-");
  return handleized;
}

// node_modules/@searchspring/snap-toolbox/dist/esm/filters/stripHTML.js
function stripHTML(input) {
  if (typeof input != "string") {
    return input;
  }
  return input.replace(/<(?:.|\n)*?>/gm, " ").replace(/\s+/g, " ").trim();
}

// node_modules/@searchspring/snap-toolbox/dist/esm/filters/truncate.js
function truncate(input, limit, append) {
  if (typeof input != "string" || input.length <= limit) {
    return input;
  }
  const lastSpace = input.lastIndexOf(" ", limit);
  const trimIndex = lastSpace != -1 ? lastSpace : limit - 1;
  return input.substr(0, trimIndex) + (append ? append : "");
}

// node_modules/@searchspring/snap-toolbox/dist/esm/featureFlags/featureFlags.js
function getFlags(userAgent = "") {
  userAgent = (userAgent || (window.navigator || {}).userAgent || "").toLowerCase();
  const isIE = /* @__PURE__ */ function() {
    let ieVersion;
    return function isIE2() {
      if (ieVersion === void 0) {
        const version2 = (userAgent.match(/(msie|trident\/7.0; rv:) ?([0-9]{1,2})\./) || [])[2];
        ieVersion = version2 ? Number(version2) : false;
      }
      return ieVersion;
    };
  }();
  return {
    cors: function() {
      return !isIE() || isIE() >= 10;
    },
    cookies: function() {
      return window.navigator && window.navigator.cookieEnabled && !("doNotTrack" in window.navigator && window.navigator.doNotTrack === "1");
    },
    storage: function() {
      const test = "ss-test";
      try {
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
        return true;
      } catch (e) {
        return false;
      }
    }
  };
}
var flags = getFlags();
var featureFlags = {
  cors: flags.cors(),
  cookies: flags.cookies(),
  storage: flags.storage()
};

// node_modules/@searchspring/snap-toolbox/dist/esm/cookies/cookies.js
var cookies = {
  set: (name, val, sameSite, expires) => {
    sameSite = sameSite || "Lax";
    let cookie = name + "=" + encodeURIComponent(val) + ";SameSite=" + sameSite + ";path=/;";
    if (window.location.protocol == "https:") {
      cookie += "Secure;";
    }
    if (expires) {
      const d = /* @__PURE__ */ new Date();
      d.setTime(d.getTime() + expires);
      cookie += "expires=" + d["toUTCString"]() + ";";
    }
    window.document.cookie = cookie;
  },
  get: (name) => {
    name = name + "=";
    const ca = window.document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return decodeURIComponent(c.substring(name.length, c.length));
      }
    }
    return "";
  },
  unset: (name) => {
    window.document.cookie = name + "=; path=/; Max-Age=-99999999;";
  }
};

// node_modules/@searchspring/snap-toolbox/dist/esm/url/url.js
var url = (href) => {
  if (!href) {
    return;
  }
  const [urlWithoutHash, hash] = href.split("#");
  const [base, queryParams] = urlWithoutHash.split("?");
  const params = {
    query: {},
    hash
  };
  queryParams?.split("&").forEach((entry) => {
    const [key, value] = entry.split("=");
    params.query[key] = value;
  });
  const urlfunction = () => {
    const queryString = Object.keys(params.query).map((key) => `${key}=${params.query[key]}`).join("&");
    return `${base}${queryString ? "?" + queryString : ""}${params.hash ? "#" + params.hash : ""}`;
  };
  return {
    base,
    params,
    url: urlfunction
  };
};

// node_modules/@searchspring/snap-toolbox/package.json
var package_default = {
  name: "@searchspring/snap-toolbox",
  version: "0.46.0",
  description: "Snap Toolbox",
  main: "dist/cjs/index.js",
  module: "dist/esm/index.js",
  author: "Searchspring",
  license: "MIT",
  repository: "https://github.com/searchspring/snap",
  publishConfig: {
    access: "public"
  },
  scripts: {
    build: "rm -rf ./dist && tsc && tsc -p tsconfig.cjs.json",
    "build:docs": "typedoc --out docs src/index.ts",
    dev: "tsc --watch",
    format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
    lint: "eslint 'src/**/*.{js,jsx,ts,tsx}'",
    test: "jest",
    "test:watch": "jest --watch"
  },
  sideEffects: false,
  files: [
    "dist/**/*"
  ],
  gitHead: "b92fc5fe0dd848d4ccdd6242dce7a70be53cb99c"
};

// node_modules/@searchspring/snap-toolbox/dist/esm/version/version.js
var { version } = package_default;

// node_modules/@searchspring/snap-toolbox/dist/esm/charsParams/charsParams.js
function charsParams(params) {
  if (typeof params != "object") {
    throw new Error("function requires an object");
  }
  const count = Object.keys(params).reduce((count2, key) => {
    const keyLength = key.length;
    const value = params[key];
    if (Array.isArray(value)) {
      return count2 + value.reduce((length, val) => {
        return length + keyLength + 1 + ("" + val).length;
      }, 0);
    } else {
      return count2 + keyLength + 1 + ("" + value).length;
    }
  }, 1);
  return count;
}

// node_modules/@searchspring/snap-store-mobx/dist/esm/Abstract/AbstractStore.js
var AbstractStore = class {
  constructor(config) {
    this.custom = {};
    this.loading = false;
    this.loaded = false;
    this.config = config;
    makeObservable(this, {
      custom: observable,
      loading: observable,
      loaded: observable
    });
  }
  setConfig(newConfig) {
    this.config = newConfig;
  }
  toJSON(thing = this) {
    return toJS(thing);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchMerchandisingStore.js
var ContentType;
(function(ContentType2) {
  ContentType2["HEADER"] = "header";
  ContentType2["BANNER"] = "banner";
  ContentType2["FOOTER"] = "footer";
  ContentType2["LEFT"] = "left";
  ContentType2["INLINE"] = "inline";
})(ContentType || (ContentType = {}));
var SearchMerchandisingStore = class {
  constructor(services, merchData) {
    this.redirect = "";
    this.content = {};
    this.campaigns = [];
    if (merchData) {
      this.redirect = merchData.redirect || "";
      if (merchData.content) {
        Object.values(ContentType).forEach((type) => {
          if (merchData.content && merchData.content[type]) {
            this.content[type] = new Content(merchData.content[type]);
          }
        });
      }
      if (merchData.campaigns) {
        this.campaigns = merchData.campaigns;
        merchData.campaigns.forEach((campaign) => {
          if (campaign.type == "landing-page") {
            this.landingPage = campaign;
          }
        });
      }
      if (merchData.personalized)
        this.personalized = merchData.personalized;
    }
  }
};
var Content = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(content) {
    super(...content);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchFacetStore.js
var import_deepmerge = __toESM(require_cjs());
var SearchFacetStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(config, services, storage, facetsData = [], pagination = {}, meta, merchandising) {
    const facets = facetsData.filter((facet) => {
      const facetMeta = facet.field && meta.facets && meta.facets[facet.field];
      if (!facetMeta)
        return false;
      if (facetMeta.display == "slider" && facet.type !== "range" || facet.type == "range" && facetMeta.display !== "slider") {
        return false;
      }
      const facetConfig = config.settings?.facets?.fields && facet.field && config.settings?.facets?.fields[facet.field];
      const shouldTrim = typeof facetConfig?.trim == "boolean" ? facetConfig.trim : config.settings?.facets?.trim;
      if (shouldTrim) {
        if (facet.type === "range" && facet?.range?.low == facet?.range?.high) {
          return false;
        } else if (facet.values?.length == 0) {
          return false;
        } else if (!facet.filtered && facet.values?.length == 1) {
          if (merchandising?.content?.inline) {
            return facet.values[0].count + merchandising.content?.inline.length != pagination.totalResults;
          } else {
            return facet.values[0].count != pagination.totalResults;
          }
        }
      }
      return true;
    }).map((facet) => {
      const facetMeta = facet.field && meta.facets && meta.facets[facet.field];
      const facetConfig = (0, import_deepmerge.default)({ ...config.settings?.facets, fields: void 0 }, config.settings?.facets?.fields && facet.field && config.settings?.facets?.fields[facet.field] || {});
      delete facetConfig.fields;
      switch (facet.type) {
        case "range":
          return new RangeFacet(services, storage, facet, facetMeta || {}, facetConfig);
        case "value":
        case "range-buckets":
        default:
          return new ValueFacet(services, storage, facet, facetMeta || {}, facetConfig);
      }
    });
    super(...facets);
  }
};
var Facet = class {
  constructor(services, storage, facet, facetMeta, config) {
    this.filtered = false;
    this.custom = {};
    this.collapsed = false;
    this.display = "";
    this.label = "";
    this.services = services;
    this.storage = storage;
    Object.assign(this, facetMeta, facet);
    makeObservable(this, {
      type: observable,
      field: observable,
      filtered: observable,
      custom: observable,
      collapsed: observable,
      display: observable,
      label: observable,
      clear: computed,
      toggleCollapse: action
    });
    const collapseData = this.storage.get(`facets.${this.field}.collapsed`);
    this.collapsed = collapseData ?? this.collapsed;
    if (this.filtered && this.collapsed && typeof collapseData == "undefined" && config.autoOpenActive) {
      this.toggleCollapse();
    }
  }
  get clear() {
    return {
      url: this.services.urlManager.remove("page").remove(`filter.${this.field}`)
    };
  }
  toggleCollapse() {
    this.collapsed = !this.collapsed;
    this.storage.set(`facets.${this.field}.collapsed`, this.collapsed);
  }
};
var RangeFacet = class extends Facet {
  constructor(services, storage, facet, facetMeta, config) {
    super(services, storage, facet, facetMeta, config);
    this.range = {
      low: 0,
      high: 0
    };
    this.active = {
      low: 0,
      high: 0
    };
    this.step = facet?.step;
    const storedRange = config.storeRange && this.storage.get(`facets.${this.field}.range`);
    if (storedRange && facet.filtered && (facet.range?.low > storedRange.low || facet.range?.high < storedRange.high)) {
      this.range = this.storage.get(`facets.${this.field}.range`);
    } else {
      this.storage.set(`facets.${this.field}.range`, facet.range);
      this.range = facet.range;
    }
    this.active = facet.active || facet.range;
    this.formatSeparator = facetMeta?.formatSeparator || "-";
    this.formatValue = facetMeta?.formatValue || "%01.2f";
    makeObservable(this, {
      step: observable,
      range: observable,
      active: observable,
      formatSeparator: observable,
      formatValue: observable
    });
  }
};
var ValueFacet = class extends Facet {
  constructor(services, storage, facet, facetMeta, config) {
    super(services, storage, facet, facetMeta, config);
    this.values = [];
    this.search = {
      input: ""
    };
    this.overflow = {
      enabled: false,
      limited: true,
      limit: 0,
      remaining: void 0,
      setLimit: function(limit) {
        if (limit != this.limit) {
          this.enabled = true;
          this.limit = limit;
          this.calculate();
        }
      },
      toggle: (val) => {
        if (typeof val != "undefined") {
          this.overflow.limited = val;
        } else {
          this.overflow.limited = !this.overflow.limited;
        }
        this.storage.set(`facets.${this.field}.overflow.limited`, this.overflow.limited);
        this.overflow.calculate();
      },
      calculate: () => {
        if (this.overflow.limit > 0) {
          const remaining = this.values.length - this.overflow.limit;
          if (remaining > 0 && !this.search.input) {
            this.overflow.enabled = true;
            if (this.overflow.limited) {
              this.overflow.remaining = remaining;
            } else {
              this.overflow.remaining = 0;
            }
          } else {
            this.overflow.enabled = false;
          }
        }
      }
    };
    this.multiple = this.multiple;
    this.values = facet.values && facet.values.map((value) => {
      switch (facet.type) {
        case "value":
          if (facetMeta.display === "hierarchy") {
            const filteredValues = facet?.values?.filter((value2) => value2.filtered) || [];
            return new FacetHierarchyValue(services, this, value, filteredValues);
          } else {
            value.value = value?.value?.toString();
            return new FacetValue(services, this, value);
          }
        case "range-buckets":
          return new FacetRangeValue(services, this, value);
      }
    }) || [];
    if (config.pinFiltered && facetMeta.display !== "hierarchy") {
      this.values.sort((a, b) => Number(b.filtered) - Number(a.filtered));
    }
    const overflowLimitedState = this.storage.get(`facets.${this.field}.overflow.limited`);
    if (typeof overflowLimitedState != "undefined") {
      this.overflow.toggle(overflowLimitedState);
    }
    makeObservable(this, {
      values: observable,
      search: observable,
      multiple: observable,
      overflow: observable,
      refinedValues: computed
    });
    reaction(() => this.search.input, () => {
      this.overflow.calculate();
    });
  }
  get refinedValues() {
    let values = this.values || [];
    if (this.search.input) {
      const search = new RegExp(escapeRegExp(this.search.input), "i");
      values = this.values.filter((value) => String(value?.label || "").match(search));
    }
    if (this.overflow.enabled && this.overflow.limited) {
      values = values.slice(0, this.overflow.limit);
    }
    return values;
  }
};
var FacetValue = class {
  constructor(services, facet, value) {
    Object.assign(this, value);
    if (this.filtered) {
      this.url = services.urlManager.remove("page").remove(`filter.${facet.field}`, value.value);
    } else {
      let valueUrl = services.urlManager.remove("page");
      if (facet.multiple == "single") {
        valueUrl = valueUrl?.remove(`filter.${facet.field}`);
      }
      this.url = valueUrl?.merge(`filter.${facet.field}`, value.value);
    }
  }
};
var FacetHierarchyValue = class extends FacetValue {
  constructor(services, facet, value, filteredValues) {
    super(services, facet, value);
    this.level = 0;
    this.history = false;
    if (value.value && facet.hierarchyDelimiter) {
      this.level = value.value.split(facet.hierarchyDelimiter).length;
    }
    if (facet.filtered && filteredValues?.length) {
      const filteredLevel = facet?.hierarchyDelimiter && filteredValues[0].value?.split(facet.hierarchyDelimiter).length;
      if (filteredLevel && this.level <= filteredLevel) {
        this.history = true;
      }
    }
    if (value.value) {
      this.url = services.urlManager.remove("page").set(`filter.${facet.field}`, value.value);
    } else {
      this.url = services.urlManager.remove("page").remove(`filter.${facet.field}`);
    }
  }
};
var FacetRangeValue = class {
  constructor(services, facet, value) {
    Object.assign(this, value);
    if (this.filtered) {
      this.url = services.urlManager.remove("page").remove(`filter.${facet.field}`, [{ low: this.low, high: this.high }]);
    } else {
      let valueUrl = services.urlManager.remove("page");
      if (facet.multiple == "single") {
        valueUrl = valueUrl?.remove(`filter.${facet.field}`);
      }
      this.url = valueUrl?.merge(`filter.${facet.field}`, [{ low: this.low, high: this.high }]);
    }
  }
};
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchFilterStore.js
var SearchFilterStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(services, filtersData = [], meta) {
    const filters = filtersData.map((filter) => {
      const field = filter.field;
      const facetMeta = meta.facets && meta.facets[field];
      switch (filter.type) {
        case "range":
          const rangeFilter = filter;
          return new RangeFilter(services, rangeFilter, facetMeta);
        case "value":
        default:
          const valueFilter = filter;
          return new Filter(services, valueFilter, facetMeta);
      }
    });
    super(...filters);
  }
};
var Filter = class {
  constructor(services, filter, meta) {
    this.facet = {
      field: filter.field,
      label: meta?.label || filter.field
    };
    this.value = {
      value: filter.value,
      label: filter.label
    };
    this.label = `${this.facet.label}: ${this.value.label}`;
    this.url = services?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, this.value.value);
    makeObservable(this, {
      facet: observable,
      value: observable,
      label: observable
    });
  }
};
var RangeFilter = class {
  constructor(services, filter, meta) {
    this.facet = {
      field: filter.field,
      label: meta?.label || filter.field
    };
    this.value = {
      low: filter?.value?.low,
      high: filter?.value?.high,
      label: filter.label || `${filter?.value?.low} - ${filter?.value?.high}`
    };
    this.label = `${this.facet.label}: ${this.value.label}`;
    this.url = services?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, { low: this.value.low, high: this.value.high });
    makeObservable(this, {
      facet: observable,
      value: observable,
      label: observable
    });
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchPaginationStore.js
var SearchPaginationStore = class {
  constructor(config, services, paginationData = {
    page: void 0,
    pageSize: void 0,
    totalResults: void 0,
    totalPages: void 0
  }, meta) {
    const paginationSettings = config?.settings?.pagination;
    this.services = services;
    this.controllerConfig = config;
    this.page = paginationData.page;
    this.pageSize = paginationData.pageSize;
    this.totalResults = paginationData.totalResults;
    this.defaultPageSize = meta?.pagination?.defaultPageSize;
    this.totalPages = paginationData.totalPages;
    const pageSizeOptions = paginationSettings?.pageSizeOptions || [
      {
        label: `Show ${this.defaultPageSize}`,
        value: this.defaultPageSize
      },
      {
        label: `Show ${this.defaultPageSize * 2}`,
        value: this.defaultPageSize * 2
      },
      {
        label: `Show ${this.defaultPageSize * 3}`,
        value: this.defaultPageSize * 3
      }
    ];
    this.pageSizeOptions = pageSizeOptions.map((pageOption) => new PageSizeOption(this.services, this.pageSize, {
      label: pageOption.label,
      value: pageOption.value
    }));
    makeObservable(this, {
      page: observable,
      pageSize: observable,
      totalResults: observable,
      totalPages: observable,
      begin: computed,
      end: computed,
      multiplePages: computed,
      current: computed,
      first: computed,
      last: computed,
      next: computed,
      previous: computed,
      getPages: action,
      setPageSize: action
    });
  }
  get begin() {
    if (this.controllerConfig.settings?.infinite) {
      return 1;
    }
    return this.pageSize * (this.page - 1) + 1;
  }
  get end() {
    if (this.pageSize * this.page > this.totalResults) {
      return this.totalResults;
    }
    return this.pageSize * this.page;
  }
  get multiplePages() {
    return this.pageSize < this.totalResults;
  }
  get current() {
    return new Page(this.services, {
      number: this.page,
      active: true
    });
  }
  get first() {
    return new Page(this.services, {
      number: 1,
      active: this.page == 1
    });
  }
  get last() {
    return new Page(this.services, {
      number: this.totalPages,
      active: this.totalPages == this.page
    });
  }
  get next() {
    if (this.page < this.totalPages) {
      return new Page(this.services, {
        number: this.page + 1
      });
    }
  }
  get previous() {
    if (this.page > 1) {
      return new Page(this.services, {
        number: this.page - 1
      });
    }
  }
  getPages(min = 5, max) {
    if (!Number.isInteger(min)) {
      return [];
    }
    if (typeof max == "undefined" || !Number.isInteger(max)) {
      const surrounding = min - 1;
      let from = this.page;
      let to = this.page;
      let last = to - from;
      do {
        last = to - from;
        if (to < this.totalPages) {
          to++;
        }
        if (to - from >= surrounding) {
          break;
        }
        if (from > 1) {
          from--;
        }
      } while (last != to - from && to - from < surrounding);
      min = from - this.page;
      max = to - this.page;
    } else {
      min = -Math.abs(min);
      max = Math.abs(max);
    }
    const pages = [];
    for (let i = this.page + min; i <= this.page + max; i++) {
      if (i > 0 && i <= this.totalPages) {
        pages.push(new Page(this.services, {
          number: i,
          active: i == this.page
        }));
      }
    }
    return pages;
  }
  setPageSize(num) {
    if (num) {
      this.services.urlManager.remove("page").set("pageSize", num).go();
    }
  }
};
var PageSizeOption = class {
  constructor(services, currentPageSize, option) {
    this.services = services;
    this.value = option.value;
    this.label = option.label;
    this.url = this.services?.urlManager.remove("page").set("pageSize", option.value);
    this.active = Boolean(currentPageSize == option.value);
  }
};
var Page = class {
  constructor(services, page) {
    this.services = services;
    this.number = page.number;
    this.active = page.active || false;
    this.url = this.services?.urlManager?.set("page", this.number);
    this.key = this.url.href;
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchResultStore.js
var SearchResultStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(config, services, resultData, paginationData, merchData) {
    let results = (resultData || []).map((result) => {
      return new Product(services, result);
    });
    if (merchData?.content?.inline) {
      const banners = merchData.content.inline.sort(function(a, b) {
        return a.config.position.index - b.config.position.index;
      }).map((banner) => {
        return new Banner(services, banner);
      });
      if (banners && paginationData?.totalResults) {
        results = addBannersToResults(config, results, banners, paginationData);
      }
    }
    super(...results);
  }
};
var Banner = class {
  constructor(services, banner) {
    this.type = "banner";
    this.attributes = {};
    this.mappings = {
      core: {}
    };
    this.custom = {};
    this.id = "ss-ib-" + banner.config.position.index;
    this.config = banner.config;
    this.value = banner.value;
    makeObservable(this, {
      id: observable,
      mappings: observable,
      attributes: observable
    });
  }
};
var Product = class {
  constructor(services, result) {
    this.type = "product";
    this.attributes = {};
    this.mappings = {
      core: {}
    };
    this.custom = {};
    this.children = [];
    this.id = result.id;
    this.attributes = result.attributes;
    this.mappings = result.mappings;
    if (result?.children?.length) {
      this.children = result.children.map((variant, index) => {
        return new Child(services, {
          id: `${result.id}-${index}`,
          ...variant
        });
      });
    }
    makeObservable(this, {
      id: observable,
      attributes: observable,
      custom: observable
    });
    const coreObservables = Object.keys(this.mappings.core).reduce((map, key) => {
      return {
        ...map,
        [key]: observable
      };
    }, {});
    makeObservable(this.mappings.core, coreObservables);
  }
};
var Child = class {
  constructor(services, result) {
    this.type = "child";
    this.attributes = {};
    this.custom = {};
    this.id = result.id;
    this.attributes = result.attributes;
    makeObservable(this, {
      id: observable,
      attributes: observable,
      custom: observable
    });
  }
};
function addBannersToResults(config, results, banners, paginationData) {
  const productCount = results.length;
  let minIndex = paginationData.pageSize * (paginationData.page - 1);
  const maxIndex = minIndex + paginationData.pageSize;
  if (config?.settings?.infinite) {
    minIndex = 0;
  }
  banners.reduce((adding, banner) => {
    const resultCount = productCount + adding.length;
    if (banner.config.position.index >= minIndex && (banner.config.position.index < maxIndex || resultCount < paginationData.pageSize)) {
      adding.push(banner);
    }
    return adding;
  }, []).forEach((banner) => {
    const adjustedIndex = banner.config.position.index - minIndex;
    results.splice(adjustedIndex, 0, banner);
  });
  return results;
}

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchSortingStore.js
var SearchSortingStore = class {
  constructor(services, sorting, search, meta) {
    this.options = [];
    if (services && meta.sortOptions) {
      const activeSort = sorting?.length && sorting[0];
      const options = (meta.sortOptions || []).filter((option) => {
        if (!search?.query) {
          return option.type == "field";
        }
        return option;
      }).map((option, index) => {
        option.active = false;
        if (activeSort && activeSort.field == option.field && String(activeSort.direction) == String(option.direction)) {
          option.active = true;
        } else if (!activeSort && index === 0) {
          option.active = true;
        }
        option.default = false;
        if (index === 0) {
          option.default = true;
        }
        const optionObj = new Option(services, option, index);
        return optionObj;
      });
      this.options = options;
      makeObservable(this, {
        options: observable,
        current: computed
      });
    }
  }
  get current() {
    return this.options.filter((option) => option.active).pop();
  }
};
var Option = class {
  constructor(services, option, index) {
    this.active = option.active;
    this.default = option.default;
    this.field = option.field;
    this.label = option.label;
    this.direction = option.direction;
    this.type = option.type;
    this.value = `${option.label}:${option.field}:${option.direction}:${index}`;
    if (this.default) {
      this.url = services.urlManager.remove("page").remove("sort");
    } else {
      this.url = services.urlManager.remove("page").set("sort", [{ field: this.field, direction: this.direction }]);
    }
    makeObservable(this, {
      field: observable,
      label: observable,
      direction: observable,
      type: observable,
      value: observable
    });
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchQueryStore.js
var SearchQueryStore = class {
  constructor(services, search) {
    const observables = {};
    if (search?.query) {
      this.query = new Query(services, search.query);
      observables.query = observable;
    }
    if (search?.didYouMean) {
      this.didYouMean = new Query(services, search.didYouMean);
      observables.didYouMean = observable;
    }
    if (search?.originalQuery) {
      this.originalQuery = new Query(services, search.originalQuery);
      observables.originalQuery = observable;
    }
    if (search?.matchType) {
      this.matchType = search.matchType;
      observables.matchType = observable;
    }
    makeObservable(this, observables);
  }
};
var Query = class {
  constructor(services, query) {
    this.string = query;
    this.url = services?.urlManager?.remove("page").remove("filter").set("query", this.string);
    makeObservable(this, {
      string: observable
    });
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Storage/StorageStore.js
var utils = {
  cookies
};
var StorageStore = class {
  constructor(config) {
    this.type = null;
    this.expiration = 31536e6;
    this.sameSite = "Lax";
    this.key = "ss-storage";
    this.state = {};
    if (config) {
      if (config.key.trim() !== "") {
        this.key = config.key.trim();
      }
      if (config?.cookie?.expiration) {
        this.expiration = config.cookie.expiration;
      }
      if (config?.cookie?.sameSite) {
        this.sameSite = config.cookie.sameSite;
      }
      switch (config.type) {
        case StorageType.SESSION: {
          this.type = featureFlags.storage ? config.type : null;
          if (this.type) {
            this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}");
            window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
          }
          break;
        }
        case StorageType.LOCAL: {
          this.type = featureFlags.storage ? config.type : null;
          if (this.type && !window.localStorage.getItem(this.key)) {
            this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}");
            window.localStorage.setItem(this.key, JSON.stringify(this.state));
          }
          break;
        }
        case StorageType.COOKIE: {
          if (featureFlags.cookies) {
            this.type = config.type;
            const data = utils.cookies.get(this.key);
            if (data) {
              this.state = JSON.parse(data);
            }
          }
          break;
        }
        default: {
          this.type = StorageType.MEMORY;
        }
      }
    }
  }
  set(path, value) {
    const paths = path?.split(".");
    let location = this.state;
    paths?.forEach((p, i) => {
      const leaf = i == paths.length - 1;
      if (leaf) {
        location[p] = value;
      } else {
        location = location[p] = location[p] || {};
      }
    });
    switch (this.type) {
      case StorageType.SESSION:
        window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
        break;
      case StorageType.LOCAL:
        window.localStorage.setItem(this.key, JSON.stringify(this.state));
        break;
      case StorageType.COOKIE:
        utils.cookies.set(this.key, JSON.stringify(this.state), this.sameSite, this.expiration);
        break;
    }
  }
  get(path) {
    switch (this.type) {
      case StorageType.SESSION:
        const sessionData = window.sessionStorage.getItem(this.key);
        this.state = sessionData ? JSON.parse(sessionData) : {};
        break;
      case StorageType.LOCAL:
        const localData = window.localStorage.getItem(this.key);
        this.state = localData ? JSON.parse(localData) : {};
        break;
      case StorageType.COOKIE:
        const data = utils.cookies.get(this.key);
        if (data) {
          this.state = JSON.parse(data) || {};
        }
        break;
    }
    const paths = path?.split(".");
    if (!paths?.length)
      return void 0;
    let value = this.state;
    for (const p of paths) {
      if (value && typeof value[p] != "undefined") {
        value = value[p];
      } else {
        value = {};
        return;
      }
    }
    return value;
  }
  clear() {
    switch (this.type) {
      case StorageType.SESSION:
        window.sessionStorage.removeItem(this.key);
        break;
      case StorageType.LOCAL:
        window.localStorage.removeItem(this.key);
        break;
      case StorageType.COOKIE:
        utils.cookies.unset(this.key);
        break;
    }
    this.state = {};
  }
};
var StorageType;
(function(StorageType2) {
  StorageType2["SESSION"] = "session";
  StorageType2["LOCAL"] = "local";
  StorageType2["COOKIE"] = "cookie";
  StorageType2["MEMORY"] = "memory";
})(StorageType || (StorageType = {}));

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/Stores/SearchHistoryStore.js
var SearchHistoryStore = class {
  constructor(config, services) {
    this.config = config;
    this.services = services;
    if (this.config.url) {
      this.services.urlManager = this.services.urlManager.withConfig((translatorConfig) => {
        return {
          ...translatorConfig,
          urlRoot: this.config.url
        };
      });
    }
    if (!Number.isInteger(this.config.max)) {
      this.config.max = 25;
    }
    this.storage = new StorageStore({
      type: StorageType.LOCAL,
      key: `ss-history${this.config.siteId ? `-${this.config.siteId}` : ``}`
    });
    if (this.config.max === 0) {
      this.reset();
    }
    if (this.queries.length > this.config.max) {
      this.getStoredData().forEach((term, index) => {
        if (index > this.config.max - 1) {
          this.remove(term);
        }
      });
    }
  }
  get queries() {
    const queries = this.getStoredData();
    return queries.map((query) => new Query(this.services, query));
  }
  save(term) {
    if (this.config.max) {
      const history = this.getStoredData();
      const index = history.indexOf(term);
      if (index != -1) {
        history.splice(index, 1);
      }
      history.unshift(term);
      if (history.length > this.config.max) {
        history.pop();
      }
      this.storage.set("history", JSON.stringify(history));
    }
  }
  remove(term) {
    const history = this.getStoredData();
    const index = history.indexOf(term);
    if (index != -1) {
      history.splice(index, 1);
      this.storage.set("history", JSON.stringify(history));
    }
  }
  reset() {
    this.storage.clear();
  }
  getStoredData(limit) {
    const storedHistory = this.storage.get("history");
    if (storedHistory) {
      try {
        const history = JSON.parse(storedHistory);
        if (Array.isArray(history)) {
          if (limit && Number.isInteger(limit)) {
            return history.slice(0, limit);
          }
          return history;
        }
      } catch (err) {
        this.reset();
      }
    }
    return [];
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/Stores/AutocompleteFacetStore.js
var AutocompleteFacetStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(config, services, storage, facetsData, paginationData, meta, rootState, merchandising) {
    const alteredServices = { ...services, urlManager: services.urlManager.remove("filter") };
    const facets = new SearchFacetStore(config, alteredServices, storage, facetsData, paginationData, meta, merchandising);
    facets.forEach((facet) => {
      facet.values?.forEach((value) => {
        value.preview = () => {
          facets.map((facet2) => {
            facet2.filtered = false;
            facet2.values?.map((value2) => {
              value2.filtered = false;
            });
          });
          facet.filtered = true;
          value.filtered = true;
          rootState.locks.facets.lock();
          value.url.go();
        };
      });
    });
    super(...facets);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/Stores/AutocompleteQueryStore.js
var AutocompleteQueryStore = class {
  constructor(services, autocomplete, search, config) {
    const observables = {};
    if (search?.query) {
      this.query = new Query2(services.urlManager, search.query);
      observables.query = observable;
    }
    if (autocomplete?.correctedQuery) {
      if (config.settings?.integratedSpellCorrection) {
        this.correctedQuery = new Query2(services.urlManager, autocomplete.correctedQuery);
        observables.correctedQuery = observable;
      } else if (autocomplete.query) {
        this.originalQuery = new Query2(services.urlManager, autocomplete.query);
        observables.originalQuery = observable;
      }
    }
    makeObservable(this, observables);
  }
};
var Query2 = class {
  constructor(urlManager, query) {
    this.string = query;
    this.url = urlManager.set({ query: this.string });
    makeObservable(this, {
      string: observable
    });
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/Stores/AutocompleteStateStore.js
var AutocompleteStateStore = class {
  constructor(services) {
    this.focusedInput = void 0;
    this.input = void 0;
    this.locks = {
      terms: new Lock(false),
      facets: new Lock(false)
    };
    this.url = services.urlManager;
    makeObservable(this, {
      focusedInput: observable,
      locks: observable,
      input: observable,
      reset: action
    });
  }
  reset() {
    this.input = void 0;
    this.locks.terms.reset();
    this.locks.facets.reset();
  }
};
var Lock = class {
  constructor(state = false) {
    this.state = this.startState = state;
  }
  reset() {
    this.state = this.startState;
  }
  get locked() {
    return this.state;
  }
  lock() {
    this.state = true;
  }
  unlock() {
    this.state = false;
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/Stores/AutocompleteTermStore.js
var AutocompleteTermStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(services, autocomplete, paginationData, search, resetTerms, rootState, config) {
    const suggestions = [...(autocomplete?.alternatives ? autocomplete.alternatives : []).map((term) => term.text)];
    if (config.settings?.integratedSpellCorrection) {
      if (autocomplete?.correctedQuery && search?.query && autocomplete.correctedQuery.toLowerCase() != search.query.toLowerCase()) {
        suggestions.unshift(autocomplete.correctedQuery);
      }
      search?.query && suggestions.unshift(search.query);
    } else {
      if (autocomplete?.suggested?.text) {
        suggestions.unshift(autocomplete.suggested.text);
      } else if (autocomplete?.correctedQuery && paginationData.totalResults) {
        suggestions.unshift(autocomplete.correctedQuery);
      } else if (autocomplete?.query && paginationData.totalResults) {
        suggestions.unshift(autocomplete?.query);
      }
    }
    const terms = [];
    suggestions.map((term, index) => terms.push(new Term(services, {
      active: index === 0,
      value: term
    }, terms, resetTerms, rootState)));
    super(...terms);
  }
};
var Term = class {
  constructor(services, term, terms, resetTerms, rootState) {
    this.active = term.active;
    this.value = term.value;
    this.url = services?.urlManager?.set({ query: this.value });
    this.preview = () => {
      resetTerms();
      terms.map((term2) => {
        term2.active = false;
      });
      this.active = true;
      rootState.locks.terms.lock();
      rootState.locks.facets.unlock();
      this.url?.set({ query: this.value }).go();
    };
    makeObservable(this, {
      active: observable,
      value: observable
    });
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/Stores/AutocompleteTrendingStore.js
var AutocompleteTrendingStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(services, trendingData, resetTerms, rootState) {
    const terms = [];
    trendingData?.trending?.queries?.map((term) => {
      terms.push(new Term(services, {
        active: false,
        value: term.searchQuery
      }, terms, resetTerms, rootState));
    });
    super(...terms);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/Stores/AutocompleteHistoryStore.js
var AutocompleteHistoryStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(services, queries, resetTerms, rootState) {
    const terms = [];
    queries?.map((query) => {
      terms.push(new Term(services, {
        active: false,
        value: query
      }, terms, resetTerms, rootState));
    });
    super(...terms);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Autocomplete/AutocompleteStore.js
var AutocompleteStore = class extends AbstractStore {
  constructor(config, services) {
    super(config);
    if (typeof services != "object" || typeof services.urlManager?.subscribe != "function") {
      throw new Error(`Invalid service 'urlManager' passed to AutocompleteStore. Missing "subscribe" function.`);
    }
    this.services = services;
    this.state = new AutocompleteStateStore(services);
    this.storage = new StorageStore();
    this.trending = [];
    this.history = [];
    this.initHistory();
    this.reset();
    makeObservable(this, {
      state: observable,
      search: observable,
      terms: observable,
      facets: observable,
      filters: observable,
      merchandising: observable,
      results: observable,
      pagination: observable,
      sorting: observable,
      history: observable
    });
  }
  reset() {
    this.state.reset();
    this.update();
    this.resetTerms();
  }
  initHistory() {
    const limit = this.config.settings?.history?.limit;
    if (limit) {
      const historyStore = new SearchHistoryStore({ siteId: this.config.globals?.siteId }, this.services);
      this.history = new AutocompleteHistoryStore(this.services, historyStore.getStoredData(limit), () => {
        this.resetTerms();
      }, this.state);
    }
  }
  resetTerms() {
    this.resetSuggestions();
    this.resetTrending();
    this.resetHistory();
  }
  resetSuggestions() {
    this.terms?.forEach((term) => term.active = false);
  }
  resetTrending() {
    this.trending?.forEach((term) => term.active = false);
  }
  resetHistory() {
    this.history?.forEach((term) => term.active = false);
  }
  setService(name, service) {
    if (this.services[name] && service) {
      this.services[name] = service;
      if (name === "urlManager") {
        this.state.url = service;
        this.initHistory();
      }
    }
  }
  updateTrendingTerms(data) {
    this.trending = new AutocompleteTrendingStore(this.services, data, () => {
      this.resetTerms();
    }, this.state);
  }
  update(data = {}) {
    if (!data)
      return;
    this.error = void 0;
    this.loaded = !!data.pagination;
    this.meta = data.meta || {};
    if (data.search) {
      this.state.url = this.services.urlManager = this.services.urlManager.set("query", data.search.query);
    }
    if (!this.state.locks.terms.locked) {
      this.terms = new AutocompleteTermStore(this.services, data.autocomplete || {}, data.pagination || {}, data.search || {}, () => {
        this.resetTerms();
      }, this.state, this.config);
      data.autocomplete && this.state.locks.terms.lock();
    }
    this.merchandising = new SearchMerchandisingStore(this.services, data.merchandising || {});
    this.search = new AutocompleteQueryStore(this.services, data.autocomplete || {}, data.search || {}, this.config);
    if (!this.state.locks.facets.locked) {
      this.facets = new AutocompleteFacetStore(this.config, this.services, this.storage, data.facets || [], data.pagination || {}, this.meta, this.state, data.merchandising || {});
    }
    this.filters = new SearchFilterStore(this.services, data.filters, this.meta);
    this.results = new SearchResultStore(this.config, this.services, data.results || [], data.pagination, data.merchandising);
    if (this.results.length === 0 && !this.trending.filter((term) => term.active).length || this.terms?.filter((term) => term.active).length) {
      this.resetTrending();
    }
    this.pagination = new SearchPaginationStore(this.config, this.services, data.pagination, this.meta);
    this.sorting = new SearchSortingStore(this.services, data.sorting || [], data.search || {}, this.meta);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Finder/Stores/FinderSelectionStore.js
var FinderSelectionStore = class extends Array {
  static get [Symbol.species]() {
    return Array;
  }
  constructor(config, services, { state, facets, meta, loading, storage, selections }) {
    const selectedSelections = [];
    if (selections?.length) {
      config.fields.forEach((fieldObj) => {
        const storedData = selections.find((selection) => selection.facet.field === fieldObj.field);
        if (storedData) {
          const { facet, selected } = storedData;
          if (facet?.hierarchyDelimiter) {
            selections.forEach((selection, index) => {
              const levels = fieldObj?.levels || facet?.values[facet?.values.length - 1]?.value.split(facet.hierarchyDelimiter);
              const levelConfig = { index, label: fieldObj.levels ? levels[index] : "", key: `ss-${index}` };
              const storageKey = generateStorageKey(config.id, facet.field);
              storage.set(`${storageKey}.${levelConfig.key}.values`, selection.data);
              storage.set(`${storageKey}.${levelConfig.key}.selected`, selection.selected);
              const selectionHierarchy = new SelectionHierarchy(services, config.id, state, facet, levelConfig, loading, storage);
              if (config.persist?.lockSelections) {
                selectionHierarchy.disabled = true;
              }
              if (selection.selected) {
                services.urlManager = services.urlManager.set(`filter.${selection.facet.field}`, selection.selected);
              }
              selectedSelections.push(selectionHierarchy);
            });
          } else {
            const selection = new Selection(services, config.id, state, facet, fieldObj, loading, storage);
            selection.selected = selected;
            selection.storage.set("selected", selected);
            selection.data = facet.values;
            if (selected) {
              services.urlManager = services.urlManager.set(`filter.${facet.field}`, selected);
            }
            if (config.persist?.lockSelections) {
              selection.disabled = true;
            }
            selectedSelections.push(selection);
          }
        }
      });
    } else if (facets && meta) {
      config?.fields && facets.sort((a, b) => {
        const fields = config.fields.map((fieldConfig) => fieldConfig.field);
        return fields.indexOf(a.field) - fields.indexOf(b.field);
      });
      config?.fields?.forEach((fieldObj) => {
        let facet = facets.filter((facet2) => facet2.field == fieldObj.field).pop();
        facet = {
          ...meta?.facets && meta.facets[fieldObj.field] || {},
          ...facet
        };
        const isHierarchy = facet?.display === "hierarchy";
        if (isHierarchy) {
          const filtered = facet.values?.filter((value) => value.filtered).pop();
          if (filtered) {
            const filteredLevel = filtered.value?.split(facet?.hierarchyDelimiter).length;
            facet.values = facet.values?.filter((value, index) => {
              return value.value && value.value.split(facet?.hierarchyDelimiter).length > filteredLevel || index == facet.values?.length - 1;
            });
          }
          const levels = fieldObj?.levels || facet?.values && facet?.values[facet?.values?.length - 1].value?.split(facet.hierarchyDelimiter);
          levels?.map((level, index) => {
            const levelConfig = { index, label: fieldObj.levels ? level : "", key: `ss-${index}` };
            selectedSelections.push(new SelectionHierarchy(services, config.id, state, facet, levelConfig, loading, storage));
          });
        } else {
          selectedSelections.push(new Selection(services, config.id, state, facet, fieldObj, loading, storage));
        }
      });
    }
    super(...selectedSelections);
  }
};
var SelectionBase = class {
  constructor(services, id, state, facet, selectionConfig, loading, storageStore) {
    this.filtered = false;
    this.collapsed = false;
    this.display = "";
    this.disabled = false;
    this.selected = "";
    this.custom = {};
    this.services = services;
    this.loading = loading;
    this.state = state;
    this.id = id;
    this.config = selectionConfig;
    this.facet = facet;
    this.type = facet.type;
    this.field = facet.field;
    this.filtered = facet.filtered;
    this.collapsed = facet.collapsed;
    this.display = facet.display;
    this.label = facet.label;
    this.multiple = facet.multiple;
    this.storage = {
      key: generateStorageKey(this.id, this.field),
      get: function(key) {
        const path = this.key + (key ? `.${key}` : "");
        return storageStore.get(path);
      },
      set: function(key, value) {
        const path = this.key + (key ? `.${key}` : "");
        return storageStore.set(path, value);
      }
    };
  }
  get values() {
    const values = [...this.data || []];
    values.unshift({
      filtered: false,
      value: "",
      label: this.config.label || this.label
    });
    return values;
  }
};
var Selection = class extends SelectionBase {
  constructor(services, id, state, facet, config, loading, storageStore) {
    super(services, id, state, facet, config, loading, storageStore);
    this.loading = loading;
    this.storage.set("values", facet.values);
    const storageData = this.storage.get();
    this.data = storageData.values;
    this.disabled = !this.values.length;
    this.selected = this.disabled ? "" : storageData.selected || "";
  }
  select(value = "") {
    if (this.loading)
      return;
    this.selected = value;
    this.storage.set("selected", value);
    this.state.persisted = false;
    if (!value) {
      this.services.urlManager.remove(`filter.${this.field}`).go();
    } else {
      this.services.urlManager.set(`filter.${this.field}`, value).go();
    }
  }
};
var SelectionHierarchy = class extends SelectionBase {
  constructor(services, id, state, facet, config, loading, storageStore) {
    super(services, id, state, facet, config, loading, storageStore);
    this.hierarchyDelimiter = facet.hierarchyDelimiter;
    let storageData = this.storage.get();
    if (!storageData) {
      this.storage.set(`${this.config.key}.values`, facet.values);
      storageData = this.storage.get();
    } else if (storageData[this.config.key]?.values) {
      this.selected = storageData[this.config.key]?.selected || "";
    } else {
      const storedLevels = this.storage.get();
      const levels = Object.keys(storedLevels).map((a, index) => `ss-${index}`);
      !levels.includes(this.config.key) && levels.push(this.config.key);
      const selectedLevels = Object.keys(storedLevels).filter((key) => storedLevels[key].selected);
      const lastSelected = selectedLevels[selectedLevels.length - 1];
      const labelIndex = levels.indexOf(this.config.key);
      const lastSelectedIndex = levels.indexOf(lastSelected);
      if (lastSelectedIndex != -1 && labelIndex == lastSelectedIndex + 1) {
        this.storage.set(`${this.config.key}.values`, facet.values);
      } else {
        this.disabled = true;
      }
    }
    this.data = storageData[this.config.key]?.values || [];
  }
  select(value = "") {
    if (this.loading)
      return;
    this.selected = value;
    this.state.persisted = false;
    const selectedLevel = this.config.index;
    const storedLevels = this.storage.get();
    const keysToRemove = Object.keys(storedLevels).slice(selectedLevel);
    Object.keys(storedLevels).reverse().forEach((key) => {
      if (key == this.config.key) {
        this.storage.set(`${key}.selected`, value);
      } else if (keysToRemove.includes(key)) {
        this.storage.set(`${key}`, {});
      }
      value = value || this.storage.get(`${key}.selected`);
    });
    if (!value) {
      this.services.urlManager.remove(`filter.${this.field}`).go();
    } else {
      this.services.urlManager.set(`filter.${this.field}`, value).go();
    }
  }
};
function generateStorageKey(id, field) {
  return `ss-finder-${id}.${field}`;
}

// node_modules/@searchspring/snap-store-mobx/dist/esm/Finder/FinderStore.js
var FinderStore = class extends AbstractStore {
  constructor(config, services) {
    super(config);
    this.meta = {};
    this.state = {
      persisted: false
    };
    this.save = () => {
    };
    this.reset = () => {
      if (this.config.persist?.enabled) {
        this.persistedStorage?.clear();
        this.state.persisted = false;
      }
      if (this.services.urlManager.state.filter) {
        this.storage.clear();
        this.selections = [];
        this.loaded = false;
      }
    };
    if (typeof services != "object" || typeof services.urlManager?.subscribe != "function") {
      throw new Error(`Invalid service 'urlManager' passed to AutocompleteStore. Missing "subscribe" function.`);
    }
    this.services = services;
    if (config.persist?.enabled) {
      this.persistedStorage = new StorageStore({
        type: StorageType.LOCAL,
        key: `ss-${config.id}-persisted`
      });
    }
    this.storage = new StorageStore();
    this.update({ meta: {} });
    makeObservable(this, {
      selections: observable,
      pagination: observable
    });
  }
  setService(name, service) {
    if (this.services[name] && service) {
      this.services[name] = service;
    }
  }
  loadPersisted() {
    if (this.config.persist?.enabled && this.persistedStorage) {
      const date = this.persistedStorage.get("date");
      const data = this.persistedStorage.get("data");
      const config = this.persistedStorage.get("config");
      const selections = this.persistedStorage.get("selections");
      const isExpired = this.config.persist.expiration && Date.now() - date > this.config.persist.expiration;
      if (data && selections.filter((selection) => selection.selected).length) {
        const stringifiedPersistedConfig = JSON.stringify({ ...config, plugins: [], middleware: {} });
        const stringifiedConfig = JSON.stringify({ ...this.config, plugins: [], middleware: {} });
        if (stringifiedPersistedConfig === stringifiedConfig && !isExpired) {
          this.update(data, selections);
          this.state.persisted = true;
          this.services.urlManager.go();
        } else {
          this.reset();
        }
      }
    }
  }
  update(data, selectedSelections) {
    this.error = void 0;
    this.loaded = !!data.pagination;
    this.meta = data.meta;
    this.pagination = new SearchPaginationStore(this.config, this.services, data.pagination, this.meta);
    this.selections = new FinderSelectionStore(this.config, this.services, {
      state: this.state,
      facets: data.facets || [],
      meta: this.meta,
      loading: this.loading,
      storage: this.storage,
      selections: selectedSelections || []
    });
    this.save = () => {
      if (this.config.persist?.enabled && this.persistedStorage && this?.selections?.filter((selection) => selection.selected).length) {
        this.persistedStorage.set("config", this.config);
        this.persistedStorage.set("data", data);
        this.persistedStorage.set("date", Date.now());
        this.persistedStorage.set("selections", this.selections.map((selection) => {
          return {
            selected: selection.selected,
            data: selection.data,
            facet: selection.facet
          };
        }));
      }
    };
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Search/SearchStore.js
var SearchStore = class extends AbstractStore {
  constructor(config, services) {
    super(config);
    if (typeof services != "object" || typeof services.urlManager?.subscribe != "function") {
      throw new Error(`Invalid service 'urlManager' passed to SearchStore. Missing "subscribe" function.`);
    }
    this.services = services;
    this.storage = new StorageStore();
    const historyConfig = {
      url: this.config.settings?.history?.url,
      max: this.config.settings?.history?.max
    };
    if (this.config.globals?.siteId) {
      historyConfig.siteId = this.config.globals?.siteId;
    }
    this.history = new SearchHistoryStore(historyConfig, this.services);
    this.update();
    makeObservable(this, {
      search: observable,
      merchandising: observable,
      facets: observable,
      filters: observable,
      results: observable,
      pagination: observable,
      sorting: observable
    });
  }
  /*
  TODO: refactor sub-store interfaces
  
  interface StoreParameters {
      config?: StoreConfigs;
      services?: StoreServices;
      stores?: {
          storage?: StorageStore;
          state?: StateStore;
      };
      data?: SearchResponseModel & { meta: MetaResponseModel };
  }
  */
  reset() {
    this.update();
  }
  update(data = {}) {
    this.error = void 0;
    this.loaded = !!data.pagination;
    this.meta = data.meta || {};
    this.merchandising = new SearchMerchandisingStore(this.services, data?.merchandising || {});
    this.search = new SearchQueryStore(this.services, data?.search || {});
    this.facets = new SearchFacetStore(this.config, this.services, this.storage, data.facets, data?.pagination || {}, this.meta, data?.merchandising || {});
    this.filters = new SearchFilterStore(this.services, data.filters, this.meta);
    this.results = new SearchResultStore(this.config, this.services, data?.results || [], data.pagination, data.merchandising);
    this.pagination = new SearchPaginationStore(this.config, this.services, data.pagination, this.meta);
    this.sorting = new SearchSortingStore(this.services, data?.sorting || [], data?.search || {}, this.meta);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Recommendation/Stores/RecommendationProfileStore.js
var RecommendationProfileStore = class {
  constructor(services, data) {
    this.display = {};
    if (!data?.profile?.tag) {
      return;
    }
    this.tag = data.profile.tag;
    this.placement = data.profile.placement;
    this.display = data.profile.display;
    makeObservable(this, {
      tag: observable,
      placement: observable,
      display: observable
    });
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/Recommendation/RecommendationStore.js
var RecommendationStore = class extends AbstractStore {
  constructor(config, services) {
    super(config);
    this.loaded = false;
    if (typeof services != "object" || typeof services.urlManager?.subscribe != "function") {
      throw new Error(`Invalid service 'urlManager' passed to AutocompleteStore. Missing "subscribe" function.`);
    }
    this.services = services;
    this.reset();
    makeObservable(this, {
      profile: observable,
      results: observable
    });
  }
  reset() {
    this.update();
  }
  update(data) {
    this.error = void 0;
    this.loaded = !!data?.profile;
    this.profile = new RecommendationProfileStore(this.services, data);
    this.results = new SearchResultStore(this.config, this.services, data?.results);
  }
};

// node_modules/@searchspring/snap-store-mobx/dist/esm/types.js
var ErrorType;
(function(ErrorType2) {
  ErrorType2["WARNING"] = "warning";
  ErrorType2["INFO"] = "info";
  ErrorType2["ERROR"] = "error";
})(ErrorType || (ErrorType = {}));

export {
  require_cjs,
  filters_exports,
  DomTargeter,
  getFlags,
  featureFlags,
  cookies,
  getContext,
  url,
  version,
  charsParams,
  AppMode,
  ContentType,
  StorageStore,
  StorageType,
  AutocompleteStore,
  FinderStore,
  SearchStore,
  RecommendationStore,
  ErrorType
};
